/** Reusable yard dressing, independent of the Hush kit. Template ids stay stable. */
import type { PieceDefinition } from '../../contract';
import { buildRowboat, HUSH_ROWBOAT } from '../../../hushHideout/rowboat';
import { buildShrine, HUSH_SHRINE } from '../../../hushHideout/shrine';
import { buildSignpost, HUSH_SIGNPOST } from '../../../hushHideout/signpost';
import { buildFirewood, HUSH_FIREWOOD } from '../../../hushHideout/firewood';
import { buildWashline, HUSH_WASHLINE } from '../../../hushHideout/washline';
import { buildBeehives, HUSH_BEEHIVES } from '../../../hushHideout/beehives';

export const YARD_PIECES = {
  // Lived-in yard dressing: reusable ground pieces for any hidden place or farmstead.
  hush_rowboat: { recipe: HUSH_ROWBOAT, build: (roles, scope) => buildRowboat(HUSH_ROWBOAT, roles, scope) },
  wayside_shrine: { recipe: HUSH_SHRINE, build: (roles, scope) => buildShrine(HUSH_SHRINE, roles, scope) },
  hush_signpost: { recipe: HUSH_SIGNPOST, build: (roles, scope) => buildSignpost(HUSH_SIGNPOST, roles, scope) },
  firewood_pile: { recipe: HUSH_FIREWOOD, build: (roles, scope) => buildFirewood(HUSH_FIREWOOD, roles, scope) },
  washing_line: { recipe: HUSH_WASHLINE, build: (roles, scope) => buildWashline(HUSH_WASHLINE, roles, scope) },
  beehive_stand: { recipe: HUSH_BEEHIVES, build: (roles, scope) => buildBeehives(HUSH_BEEHIVES, roles, scope) },
} as const satisfies Record<string, PieceDefinition>;
